<template>
    <div class="video-player">
        <div
            id="twitch-player"
            class="video"
        >
        </div>
    </div>
</template>

<script>
    import {
        loadScript,
        addDays,
    } from '@superbet-group/web.lib.utilities';

    export default {
        name: 'TwitchPlayer',
        props: {
            channel: {
                type: String,
                required: true,
            },
        },
        async mounted() {
            await this.loadRequirements();
            this.initializeVideoPlayer();
        },
        methods: {
            loadRequirements() {
                return loadScript(
                    'https://player.twitch.tv/js/embed/v1.js',
                    'twitch',
                );
            },
            /**
             * Simulates accepting Twitch's Content Classification Labels (CCL) to remove the warning overlay.
             * https://help.twitch.tv/s/article/content-classification-labels?language=en_US
             *
             * Twitch stores a JSON object in localStorage upon accepting the CCL.
             * The object has two properties: 'loggedIn' and 'loggedOut'.
             * - 'loggedIn' is always empty for embedded Twitch players.
             * - 'loggedOut' contains the labels that were accepted by the user when not logged in.
             *
             * The values for these labels are Epoch timestamps indicating when the CCL was accepted, increased by 1 month.
             *
             * This function mimics that behavior.
             */
            removeCclOverlay() {
                const loggedOutLabelObject = Object.fromEntries(
                    ['MatureGame', 'Gambling', 'SexualThemes', 'DrugsIntoxication', 'ProfanityVulgarity', 'ViolentGraphic'].map((label) => [label, addDays(30).getTime()]),
                );

                localStorage.setItem('content-classification-labels-acknowledged', JSON.stringify({
                    loggedIn: {},
                    loggedOut: loggedOutLabelObject,
                }));
            },

            initializeVideoPlayer() {
                this.removeCclOverlay();

                // eslint-disable-next-line no-undef
                this.player = new Twitch.Player('twitch-player', {
                    channel: this.channel,
                });
            },
        },
    };
</script>
